// Validators for input fields.

// String fields
export const isNotEmptyString = (value) => value !== '';

// Numeric fields (type="number")
export const isNumber = (value) => !Number.isNaN(value);
export const isPositiveNumber = (value) => !Number.isNaN(value) && value > 0;
export const isNonNegativeNumber = (value) =>
  !Number.isNaN(value) && value >= 0;
export const isPositiveInteger = (value) =>
  !Number.isNaN(value) && value > 0 && Number.isInteger(value);
